var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("카카오 로그인 이후 페이지")]),_c('p',{domProps:{"textContent":_vm._s(_vm.codes)}},[_vm._v("codes")]),_c('div',[_vm._v("email : "),_c('p',{domProps:{"textContent":_vm._s(_vm.form.email)}},[_vm._v("codes")])]),_c('div',[_vm._v("id : "),_c('p',{domProps:{"textContent":_vm._s(_vm.form.id)}},[_vm._v("codes")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }